export default {
  methods: {
    isOrderTypeItem(item) {
      return ['order', 'refund'].includes(item.type);
    },
  },
};
